import { Badge } from "@/components/ui/badge";
import { ThemeColorPreview } from "./ThemeColorPreview";
import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";
import type { ColorScheme } from "../types";
interface ThemeCardProps {
  scheme: ColorScheme;
  isSelected: boolean;
  isPro: boolean;
  isProTheme: boolean;
  onClick: () => void;
}
export const ThemeCard = ({
  scheme,
  isSelected,
  isPro,
  isProTheme,
  onClick
}: ThemeCardProps) => {
  return <button onClick={onClick} className={cn("relative overflow-hidden rounded-lg p-3 transition-all duration-200", "hover:scale-105", isSelected ? "ring-2 ring-primary ring-offset-2" : "")} style={{
    background: scheme.secondary
  }}>
      <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent bg-slate-200 hover:bg-slate-100" />
      <div className="relative space-y-2">
        <div className="flex items-center justify-between">
          <h3 style={{
          color: scheme.primary
        }} className="text-sm font-medium text-muted-foreground">
            {scheme.name}
          </h3>
          {isProTheme && <Badge variant="secondary" className="text-xs flex items-center gap-1 bg-purple-200 hover:bg-purple-100">
              <Sparkles className="w-3 h-3" />
              PRO
            </Badge>}
        </div>
        
        <ThemeColorPreview primary={scheme.primary} accent={scheme.accent} secondary={scheme.secondary} />
      </div>
    </button>;
};